import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { setBreadCrumbMapping } from 'store/actions/breadCrumb.action'

const useSetBreadcrumb = () => {
    const dispatch = useDispatch()
    const setBreadcrumb = useCallback(
        (obj: { key: string; value: string }) => {
            dispatch(setBreadCrumbMapping(obj))
        },
        [dispatch],
    )

    return setBreadcrumb
}
export default useSetBreadcrumb
